export default __webpack_public_path__ + "static/media/alcatrazKlein.4d426dff.jpg";